import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=7a080a38&"
import script from "./GatewayDetails.vue?vue&type=script&lang=js&"
export * from "./GatewayDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports